// @flow
import { DISMISS_MODAL, OPEN_RETRACT_BID_MODAL } from './modal';
import { getAuthToken, getUserData } from './user';
import { createSelector } from 'reselect';
import { getDeployment } from './config';
import { getRetractedAbsenteeBidAnalytics } from './analytics';
import type { GlobalState } from '../rootReducer';
import { postRetractBid } from '../api/bid';

/* Action Types */
export const RETRACT_BID_FAIL = 'la/ui/retractBid/FAIL';
export const RETRACT_BID_REQUEST = 'la/ui/retractBid/REQUEST';
export const RETRACT_BID_SUCCESS = 'la/ui/retractBid/SUCCESS';

// reducer
const DEFAULT_STATE = {
    bidRetracted: false,
    error: false,
    itemId: null,
    submitted: false,
    success: false,
};

export type State = {|
    ...typeof DEFAULT_STATE,
    itemId: ?number,
|};

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case DISMISS_MODAL:
            return {
                ...state,
                bidRetracted: false,
            };
        case OPEN_RETRACT_BID_MODAL:
            return {
                ...state,
                itemId: action.payload.itemId,
            };
        case RETRACT_BID_REQUEST:
            return {
                ...state,
                bidRetracted: true,
                submitted: true,
                success: false,
            };
        case RETRACT_BID_SUCCESS:
            return {
                ...state,
                submitted: false,
                success: true,
            };
        case RETRACT_BID_FAIL:
            return {
                ...state,
                error: true,
                submitted: false,
                success: false,
            };
        default:
            return state;
    }
}

/* SELECTORS */
const retractBidSelector = (state: GlobalState) => state.retractBid;

export const getUiRetractBid = createSelector(retractBidSelector, retractBid => retractBid);

export const getRetractBidItemId = (state: GlobalState) => {
    return state && state.retractBid && state.retractBid.itemId ? state.retractBid.itemId : null;
};

/* ACTION CREATORS */
const retractBidFail = error => ({
    error: true,
    payload: error,
    type: RETRACT_BID_FAIL,
});

const retractBidRequest = (itemId, retractionReason, retractionExplanation) => ({
    payload: {
        itemId,
        retractionExplanation,
        retractionReason,
    },
    type: RETRACT_BID_REQUEST,
});

const retractBidSuccess = (itemId, analytics) => ({
    meta: {
        analytics: analytics.analytics,
        itemId,
    },
    payload: itemId,
    type: RETRACT_BID_SUCCESS,
});

export const submitRetractBid = (itemId: number, retractionReason: any, retractionExplanation: any) => async (
    dispatch: Function,
    getState: Function
) => {
    try {
        const state = getState();
        const authToken = getAuthToken(state);
        const deployment = getDeployment(state);
        const userData = getUserData(state);
        const bidderId = userData.bidderId;
        dispatch(retractBidRequest(itemId, retractionReason, retractionExplanation));
        await postRetractBid({
            authToken,
            bidderId,
            deployment,
            itemId,
            retractionExplanation,
            retractionReason,
        });

        const analytics = getRetractedAbsenteeBidAnalytics(state, itemId, retractionReason, retractionExplanation);
        return dispatch(retractBidSuccess(itemId, analytics));
    } catch (error) {
        dispatch(retractBidFail(error));
    }
};
